export const DEFAULT_COMPANY_NAME = 'DentalPro';

/** Primera letra del nombre de marca (monograma en navbar, admin, login). */
export function getBrandInitial(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return 'D';
  return trimmed.charAt(0).toUpperCase();
}

export const COMPANY_UPDATED_EVENT = 'company:updated';
